export default "__VITE_PUBLIC_ASSET__06de162a__"